import { useEffect, useState, useCallback, useRef } from 'react';

export const useIdleLogoutHandler = (timeOutInterval: number, isEnabled: boolean, onIdle?: any): any => {
    const [isIdle, setIsIdle] = useState(false);
    const [elapsedTime, setElapsedTime] = useState(0);
    const lastInteractionTime = useRef<any>(Date.now());
    const timerRef: any = useRef(null);
    const countdownRef: any = useRef(null);

    const resetTimer = useCallback(() => {
        if (isEnabled) {
            clearTimeout(timerRef.current);
            clearInterval(countdownRef.current);
            setElapsedTime(0);

            timerRef.current = setTimeout(() => {
                const currentTime = Date.now();
                const diff = currentTime - lastInteractionTime.current;
                if (diff >= timeOutInterval) {
                    if (onIdle) onIdle();
                    setIsIdle(true);
                }
            }, timeOutInterval);

            // Update elapsed time every second
            countdownRef.current = setInterval(() => {
                const currentTime = Date.now();
                const elapsed = Math.floor((currentTime - lastInteractionTime.current) / 1000);
                setElapsedTime(elapsed);
            }, 1000);
        }
    }, [timeOutInterval, onIdle, isEnabled]);

    const eventHandler = useCallback(() => {
        lastInteractionTime.current = Date.now();
        setIsIdle(false);

        resetTimer();
    }, [resetTimer]);
    useEffect(() => {
        if (!isEnabled) {
            clearTimeout(timerRef.current);
            clearInterval(countdownRef.current);
            setElapsedTime(0);

            return;
        }
        const events = ['click', 'keypress', 'dblclick'];
        events.forEach((eventName) => window.addEventListener(eventName, eventHandler));
        resetTimer();
        return () => {
            events.forEach((eventName) => window.removeEventListener(eventName, eventHandler));
            clearTimeout(timerRef.current);

            clearInterval(countdownRef.current);
        };
    }, [isEnabled, eventHandler, resetTimer]);
    return { isIdle, elapsedTime };
};
